import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

/**
 * Lembrete "você deixou itens no carrinho". Subject = destinatário (User); a
 * quantidade de itens vem de content() (data). Leva ao carrinho.
 */
export default class AbandonedCartNotification extends Notification {
  icon() {
    return 'fas fa-cart-arrow-down';
  }
  href() {
    return app.route('marketplace.cart');
  }
  content() {
    const data = this.attrs.notification.content() ?? {};
    return app.translator.trans('ramon-marketplace.forum.notifications.abandoned_cart', {
      count: data.item_count ?? 0
    });
  }
  excerpt() {
    return '';
  }
}
flarum.reg.add('ramon-marketplace', 'forum/components/AbandonedCartNotification', AbandonedCartNotification);